import './Input.scss';
import React, { useId } from 'react';

function Input({
  label,
  error,
  helperText,
  id,
  name,
  value,
  onChange,
  type = 'text',
  placeholder,
  required = false,
  fullWidth = false,
  readOnly = false,
  disabled = false,
  multiline = false,
  rows = 3,
  size,
  margin,
  className = '',
  style,
  sx,
  InputProps = {},
  inputProps = {},
  InputLabelProps,
  ...rest
}) {
  const generatedId = useId();
  const fieldId = id || name || `custom-input-${generatedId}`;
  const helpId = `${fieldId}-help`;
  const hasControlledValue = value !== undefined && value !== null;
  const isReadOnly = readOnly || Boolean(InputProps.readOnly) || (hasControlledValue && !onChange);
  const inputClassName = [
    'custom-input',
    fullWidth ? 'custom-input--full' : '',
    size === 'small' ? 'custom-input--small' : '',
    margin === 'normal' ? 'custom-input--margin-normal' : '',
    isReadOnly ? 'custom-input--readonly' : '',
    disabled ? 'custom-input--disabled' : '',
    error ? 'custom-input--error' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const fieldProps = {
    id: fieldId,
    name,
    value,
    onChange,
    placeholder,
    required,
    readOnly: isReadOnly,
    disabled,
    className: 'custom-input__field',
    'aria-label': label || placeholder,
    'aria-invalid': Boolean(error),
    'aria-describedby': (helperText || error) ? helpId : undefined,
    ...inputProps,
    ...rest,
  };

  return (
    <div className={inputClassName} style={{ ...sx, ...style }}>
      {label && (
        <label className="custom-input__label" htmlFor={fieldId}>
          {label}
        </label>
      )}

      {multiline ? (
        <textarea {...fieldProps} rows={rows} />
      ) : (
        <input {...fieldProps} type={type} />
      )}
      {(helperText || error) && (
        <span id={helpId} className="custom-input__help">
          {error || helperText}
        </span>
      )}
    </div>
  );
}

export default Input;
